import { render } from "./AddMontant.vue?vue&type=template&id=569b71ae&ts=true"
import script from "./AddMontant.vue?vue&type=script&lang=ts"
export * from "./AddMontant.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__